import { FeeType } from 'ogp/services/billing-entity-service.types';
import { ProviderFactory } from 'shared/providers/provider-factory';
import { CompanyEmploymentTypes } from '@types';
import { useSiteDetection } from 'shared/hooks';
import { useGetCompanyEmploymentTypes } from 'api';

const [InternalFeeTypeProvider, useFeeTypeProvider] = ProviderFactory<FeeType[]>(
  'Fee types are only available inside FeeTypeProvider. Did you forget to render it?'
);

const FeeTypeProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  const { site } = useSiteDetection();
  const employmentTypeOfCompanyQuery = useGetCompanyEmploymentTypes(site);

  if (employmentTypeOfCompanyQuery.status !== 'success') {
    return null;
  }

  return (
    <InternalFeeTypeProvider
      value={getFeeTypesFromEmploymentType(employmentTypeOfCompanyQuery.data)}
    >
      {children}
    </InternalFeeTypeProvider>
  );
};

const getFeeTypesFromEmploymentType = (employmentType: CompanyEmploymentTypes): FeeType[] => {
  if (employmentType.offersFreelanceWork) {
    return ['platform', 'shiftManager'];
  } else {
    return ['shiftManager'];
  }
};

export { FeeTypeProvider, useFeeTypeProvider };
